const React = require("react");
const ReactIntl = require("react-intl");
const _ = require("lodash");

const {
  Input,
  Button,
  Text,
  IconButton,
  Modal,
  ModalContent,
  ModalHeader,
  Description,
  Heading,
  Strong,
  Separator,
  Layout,
} = require("@metro-ui/core");
const { Back } = require("@metro-ui/icons");
const ResendCodeTimer = require("./ResendCodeTimer");
const LoginStore = require("../../stores/LoginStore.js");
const PhoneNumber = require("../PhoneNumber/PhoneNumber.js");
const LoginActions = require("../../actions/LoginActions.js");
const ErrorCodes = require("../../utils/ErrorCodes.js");
const AppConstants = require("../../constants/AppConstants");
const defaultMessages = require("../../i18n/messages/default");
const Utils = require("../../utils/Utils.js");
const PhonePrefixes = require("../../constants/PhonePrefixes").default;
const UrlUtils = require('../../utils/urlUtils');

const country_code= UrlUtils.getParameterByName("country_code");
const numberDetails = PhonePrefixes.find((el) => el.key === country_code);
const prefixValue = numberDetails ? numberDetails : PhonePrefixes.find((el) => el.key === AppConstants.DEFAULT_PHONE_NUMBER_LANGUAGE);

const { injectIntl } = ReactIntl;

class CodesViaSmsModal extends React.Component {
  constructor(props) {
    super(props); 
    this.state = {
      code: "",
      isOtpSent: false,
      mobileNumber: "",
      prefix: prefixValue.label || "",
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.storeMobileNumber = this.storeMobileNumber.bind(this);
    this.validateOtpSentViaSms = this.validateOtpSentViaSms.bind(this);
    this.otpSentViaSmsListener = this.otpSentViaSmsListener.bind(this);
    this.totpAppValidationListener = this.totpAppValidationListener.bind(this);
    this._onBackNavigationClick = this.onBackNavigationClick.bind(this);
    this.handlePrefixChange = this.handlePrefixChange.bind(this);
    this.getNumberFormat = this.getNumberFormat.bind(this);
  }

  componentDidMount() {
    LoginStore.otpSentViaSmsListener(this.otpSentViaSmsListener);
    LoginStore.totpAppValidationListener(this.totpAppValidationListener);
  }

  componentWillUnmount() {
    this.clear();
  }

  clear() {
    LoginStore.removeOtpSentViaSmsListener(this.otpSentViaSmsListener);
    LoginStore.removeTotpAppValidationListener(this.totpAppValidationListener);
  }

  getNumberFormat() {
    const { mobileNumber, prefix } = this.state;
    if(prefix){
      return `${prefix.replace("+", "00")}${mobileNumber}`;
    }
    return `${prefix}${mobileNumber}`;
  }

  onInputChange(ev, value) {
    if (value.length > 6) value = value.slice(0, 6);
    this.setState({ code: value });
  }

  otpSentViaSmsListener() {
    let appState = LoginStore.getState();
    if (appState.otpViaSms) {
      if (appState.otpViaSms.isOtpSent) {
        this.setState({ isOtpSent: true });
        LoginActions.triggerToast(
          this.props.intl.formatMessage(
            defaultMessages[
              "loginpreferences.2famethods.codes_via_sms.msg_otpsent"
            ]
          ),
          "success",
          true
        );
        return;
      } else if (
        _.includes(
          AppConstants.LoginPreferences.ERROR_CODES_WHERE_USER_REDIRECTS,
          appState.otpViaSms.errorCode
        )
      ) {
        LoginActions.triggerToast(
          Utils.replaceAllByKeys(
            this.props.intl.formatMessage(
              defaultMessages[ErrorCodes[appState.otpViaSms.errorCode]]
            ),
            appState.otpViaSms.placeholders
          ),
          "error",
          true
        );
        if(appState.otpViaSms.errorCode === "0203005") {
          this.props.onBackNavigationClick();
        }
      } else if (appState.otpViaSms.errorCode) {
        LoginActions.triggerToast(
          this.props.intl.formatMessage(
            defaultMessages[ErrorCodes[appState.otpViaSms.errorCode]]
          ),
          "error",
          true
        );
      } else {
        LoginActions.triggerToast(
          this.props.intl.formatMessage(
            defaultMessages[ErrorCodes[AppConstants.GENERIC_ERROR_CODE]]
          ),
          "error",
          true
        );
      }
    }
  }

  totpAppValidationListener() {
    let appState = LoginStore.getState();
    if (appState.validateTotpResponse) {
      if (appState.validateTotpResponse.isValid) {
        LoginActions.triggerToast(
          this.props.intl.formatMessage(
            defaultMessages[
              "loginpreferences.2famethods.codes_via_sms.msg_setup_successful"
            ]
          ),
          "success",
          true
        );
        LoginActions.getUserMFAMethods(this.props.idToken, this.props.countryCode); // refresh the 2FA list
        this.props.onNavItemClick(2, true); //pass true to GetUserDetails
        this.props.closeModal();
        return;
      } else if (
        _.includes(
          AppConstants.LoginPreferences.ERROR_CODES_WHERE_USER_REDIRECTS,
          appState.validateTotpResponse.errorCode
        )
      ) {
        LoginActions.triggerToast(
          Utils.replaceAllByKeys(
            this.props.intl.formatMessage(
              defaultMessages[
                ErrorCodes[appState.validateTotpResponse.errorCode]
              ]
            ),
            appState.validateTotpResponse.placeholders
          ),
          "error",
          true
        );
        this.props.onNavItemClick(2);
      } else if (appState.validateTotpResponse.errorCode) {
        LoginActions.triggerToast(
          Utils.replaceAllByKeys(
            this.props.intl.formatMessage(
              defaultMessages[
                ErrorCodes[appState.validateTotpResponse.errorCode]
              ]
            ),
            appState.validateTotpResponse.placeholders
          ),
          "error",
          true
        );
      } else {
        LoginActions.triggerToast(
          this.props.intl.formatMessage(
            defaultMessages[ErrorCodes[AppConstants.GENERIC_ERROR_CODE]]
          ),
          "error",
          true
        );
      }
    }
  }

  validateOtpSentViaSms() {
    const {
      idToken,
      userType,
      realmId,
      countryCode,
      traceId,
      localeId,
      authMethod,
    } = this.props;
    const { code } = this.state;
    LoginActions.validateAddTotpAddCode(
      idToken,
      userType,
      realmId,
      countryCode,
      traceId,
      code,
      this.getNumberFormat(),
      localeId,
      authMethod,
      this.getNumberFormat()
    );
    LoginStore.otpSentViaSmsListener(this.otpSentViaSmsListener);
    LoginStore.totpAppValidationListener(this.totpAppValidationListener);
  }

  sendOtpViaSms(totpResendFlag) {
    LoginActions.genAndSendOtpUsingTempSecret(
      this.props.userType,
      this.props.idToken,
      this.getNumberFormat(),
      this.props.countryCode,
      this.props.traceId, 
      totpResendFlag
    );
  }

  storeMobileNumber(ev, value) {
    this.setState({ mobileNumber: value });
  }

  handlePrefixChange(_, value) {
    this.setState({ prefix: value });
  }

  onBackNavigationClick() {
    this.props.closeModal();
    this.clear();
  }

  renderFirstStepModalContent() {
    return (
      <>
        <Heading element="h3" className="margin-bottom-small" size="large">
          {this.props.intl.formatMessage(
            defaultMessages[
              "loginpreferences.2famethods.codes_via_sms.step_1_multiple_2fa"
            ]
          )}
        </Heading>
        <Layout direction="row" className="form-group-container">
          <PhoneNumber 
            handlePrefixChange={this.handlePrefixChange}
            storeMobileNumber={this.storeMobileNumber}
          />
        </Layout>
        <Description className="sms-description-text" size="medium">
          {this.props.intl.formatMessage(
            defaultMessages[
              "loginpreferences.2famethods.codes_via_sms.step_1_multiple_2fa_description"
            ]
          )}
        </Description>
        <Separator />
        <div className="modal-footer-container">
          <Button
            isWide
            size="medium"
            className="form-controls"
            isFullWidth={false}
            variant="primary"
            isDisabled={
              this.state.mobileNumber.length < 4 || this.state.isOtpSent
            }
            onClick={this.sendOtpViaSms.bind(this, false)}
          >
            {this.props.intl.formatMessage(
              defaultMessages[
                "loginpreferences.2famethods.codes_via_sms.send_otp_multiple_2fa"
              ]
            )}
          </Button>
        </div>
      </>
    );
  }

  renderSecondStepModalContent() {
    const otpPlaceholderhint = this.props.intl.formatMessage(
      defaultMessages["loginpreferences.2famethods.codes_via_sms.otp_hint"]
    );

    let phoneNumberReformat = this.getNumberFormat().replace(
      /^(.{4})(.{6})(.*)$/,
      "$1 $2 $3"
    );

    return (
      <div className="second-step-modal">
        <Heading className="margin-bottom-small" size="medium">
          {this.props.intl.formatMessage(
            defaultMessages[
              "loginpreferences.2famethods.codes_via_sms.step_2_multiple_2fa"
            ]
          )}
        </Heading>
        <Text className="margin-bottom-small" size="medium">
          {this.props.intl.formatMessage(
            defaultMessages[
              "loginpreferences.2famethods.codes_via_sms.step_2_multiple_2fa_details"
            ]
          )}
        </Text>
        <div>
          <Strong className="bold-phone-number">
            <span>{phoneNumberReformat}</span>
          </Strong>
          <Strong
            className="primary-color margin-left"
            onClick={() => this.setState({ isOtpSent: false })}
          >
            {this.props.intl.formatMessage(
              defaultMessages[
                "loginpreferences.2famethods.codes_via_sms.step_2_multiple_2fa_wrong_number"
              ]
            )}
          </Strong>
        </div>
        <Input
          id="verificationCode"
          placeholder={otpPlaceholderhint}
          className="form-controls verification-code-input"
          value={this.state.code}
          onChange={this.onInputChange}
          isRequired="true"
          type="number"
        />
        <ResendCodeTimer
          seconds={60}
          initialMessage={"Resend code"}
          maxTries={3}
          sendOtp={this.sendOtpViaSms.bind(this, true)}
        />
        <Separator />
        <div className="modal-footer-container">
          <Button
            isWide
            variant="primary"
            size="medium"
            className="form-controls"
            isDisabled={this.state.code.length <= 5}
            onClick={this.validateOtpSentViaSms.bind(this)}
          >
            {this.props.intl.formatMessage(
              defaultMessages[
                "loginpreferences.2famethods.codes_via_app.verify_multiple_2fa"
              ]
            )}
          </Button>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Modal
        className="codesViaSms-modal"
        aria-labelledby="modal-title"
        isOpen
        onDismiss={() => {
          this.props.closeModal();
          this.clear();
        }}
      >
        <ModalHeader align="end" isClosable padding="medium" spacing="medium">
          <IconButton
            Icon={Back}
            hasNoInteractionEffect
            label="Back"
            color="metro-blue"
            onClick={this.props.onBackNavigationClick}
          />
          {this.props.intl.formatMessage(
            defaultMessages[
              "loginpreferences.2famethods.codes_via_sms.setup_multiple_2fa"
            ]
          )}
        </ModalHeader>
        <ModalContent
          className="small-top-padding"
          direction="column"
          padding="xx-large"
          spacing="medium"
        >
          {!this.state.isOtpSent
            ? this.renderFirstStepModalContent()
            : this.renderSecondStepModalContent()}
        </ModalContent>
      </Modal>
    );
  }
}

module.exports = injectIntl(CodesViaSmsModal);
